import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import SiteBackground from "@/components/SiteBackground";
import ScrollProgress from "@/components/ScrollProgress";
import Hero from "@/components/sections/Hero";
import WhatWeDo from "@/components/sections/WhatWeDo";
import Work from "@/components/sections/Work";
import Details from "@/components/sections/Details";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import useScrollReveal from "@/hooks/useScrollReveal";

export default function LandingPage() {
  useScrollReveal();

  useEffect(() => {
    document.title = "Creston — We build websites.";
  }, []);

  return (
    <main
      className="relative min-h-screen bg-background text-foreground"
      data-testid="landing-page"
    >
      <SiteBackground />
      <ScrollProgress />
      <Navbar />
      <Hero />
      <WhatWeDo />
      <Work />
      <Details />
      <Contact />
      <Footer />
    </main>
  );
}
